module.exports = __webpack_public_path__ + "img/logo_rectangle.ec822eda.png";